"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var typeCheck_exports = {};
__export(typeCheck_exports, {
  typeCheck: () => typeCheck
});
module.exports = __toCommonJS(typeCheck_exports);
var import_topo_core = require("@cartographerio/topo-core");
var import_geometry = require("@cartographerio/geometry");
var import_guard = require("@cartographerio/guard");
var import_types = require("@cartographerio/types");
var import_util = require("@cartographerio/util");
var import_describe = require("./describe.js");
function fail(expected, actual, path) {
  return (0, import_topo_core.errorMessage)(`Expected ${(0, import_describe.describeSchema)(expected)}, found ${JSON.stringify(actual)}`, path, { actual });
}
function typeCheck(schema, value, path = []) {
  switch (schema.type) {
    case "Boolean":
      return (0, import_guard.isBoolean)(value) ? [] : [fail(schema, value, path)];
    case "Integer":
      return (0, import_guard.isInteger)(value) ? [] : [fail(schema, value, path)];
    case "Number":
      return (0, import_guard.isNumber)(value) ? [] : [fail(schema, value, path)];
    case "String":
      return (0, import_guard.isString)(value) ? [] : [fail(schema, value, path)];
    case "Uuid":
      return (0, import_types.isValidUuid)(value) ? [] : [fail(schema, value, path)];
    case "Timestamp":
      return (0, import_types.isValidTimestamp)(value) ? [] : [fail(schema, value, path)];
    case "Geometry":
      switch (schema.geometryType) {
        case "Point":
          return (0, import_geometry.isPoint)(value) ? [] : [fail(schema, value, path)];
        case "MultiPoint":
          return (0, import_geometry.isMultiPoint)(value) ? [] : [fail(schema, value, path)];
        case "LineString":
          return (0, import_geometry.isLineString)(value) ? [] : [fail(schema, value, path)];
        case "MultiLineString":
          return (0, import_geometry.isMultiLineString)(value) ? [] : [fail(schema, value, path)];
        case "Polygon":
          return (0, import_geometry.isPolygon)(value) ? [] : [fail(schema, value, path)];
        case "MultiPolygon":
          return (0, import_geometry.isMultiPolygon)(value) ? [] : [fail(schema, value, path)];
        case void 0:
          return (0, import_geometry.isGeometryAtom)(value) ? [] : [fail(schema, value, path)];
        default:
          return (0, import_util.checkExhausted)(schema.geometryType);
      }
    case "Unknown":
      return [];
    case "Enum":
      return schema.values.includes(value) ? [] : [fail(schema, value, path)];
    case "Nullable":
      return (0, import_guard.isNull)(value) || (0, import_guard.isUndefined)(value) ? [] : typeCheck(schema.param, value, path);
    case "Array":
      if ((0, import_guard.isArray)(value)) {
        return value.reduce(
          (memo, item, index) => [...memo, ...typeCheck(schema.param, item, (0, import_topo_core.appendPath)(path, index))],
          []
        );
      } else {
        return [fail(schema, value, path)];
      }
    case "Tuple":
      if ((0, import_guard.isArray)(value)) {
        return schema.items.reduce((memo, schema2, index) => {
          return [
            ...memo,
            ...typeCheck(schema2, index < value.length ? value[index] : void 0, (0, import_topo_core.appendPath)(path, index))
          ];
        }, []);
      } else {
        return [fail(schema, value, path)];
      }
    case "Dict":
      if ((0, import_guard.isObject)(value)) {
        return Object.keys(value).reduce((memo, key) => {
          return [
            ...memo,
            ...typeCheck(schema.key, key, (0, import_topo_core.appendPath)(path, key)),
            ...typeCheck(schema.value, (0, import_guard.hasKeyOfAnyType)(value, key) ? value[key] : void 0, (0, import_topo_core.appendPath)(path, key))
          ];
        }, []);
      } else {
        return [fail(schema, value, path)];
      }
    case "Product":
      if ((0, import_guard.isObject)(value)) {
        return Object.keys(schema.fields).reduce((memo, key) => {
          return [
            ...memo,
            ...typeCheck(
              schema.fields[key],
              (0, import_guard.hasKeyOfAnyType)(value, key) ? value[key] : void 0,
              (0, import_topo_core.appendPath)(path, key)
            )
          ];
        }, []);
      } else {
        return [fail(schema, value, path)];
      }
    case "Sum":
      if ((0, import_guard.isObject)(value)) {
        const ctor = Object.keys(schema.products).find((ctor2) => (0, import_guard.hasTypeTag)(value, ctor2));
        const prodSchema = ctor ? schema.products[ctor] : void 0;
        if (prodSchema) {
          return typeCheck(prodSchema, value, path);
        } else {
          return [fail(schema, value, path)];
        }
      } else {
        return [fail(schema, value, path)];
      }
    default:
      return (0, import_util.checkExhausted)(schema);
  }
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  typeCheck
});
//# sourceMappingURL=typeCheck.js.map
